<template>
  <div class="col-12-">
    <div class="search-padd">
      <table class="table table-sm table-borderless shadow">
        <thead>
          <tr class="">
            <th>Course Name</th>
            <th class="text-center"># of Assigned</th>
            <th class="text-center"># of Completed</th>
            <th class="text-center">Last Updated</th>
            <th class="text-center">Status</th>
            <th class="text-center">Date Created</th>
            <!-- <th>Assign to</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-show="loading">
            <td colspan="6">
              <div class="loading_show"><div class="spinner-border text-danger"></div></div>
            </td>
          </tr>
          <tr v-for="(course, index) in course_lists">
            <td>{{ course.course_name }}</td>
            <td class="text-center">{{ course.no_of_assigned }}</td>
            <td class="text-center">{{ course.no_of_completed }}</td>
            <td class="text-center">{{ course.updated_at }}</td>
            <td class="text-center">{{ getStatus(course.status) }}</td>
            <td class="text-center">{{ getDate(course.created_at) }}</td>
            <!-- <td><button class="btn input-height-15 rounded">Select Users</button></td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: ['accountId'],
  data() {
    return {
      loading: false,
      course_lists: [],
      status_options: [
        { value: '', text: 'Status' },
        { value: 'Active', text: 'Published' },
      ],
    }
  },
  methods: {
    fetchCourseListitems() {
      this.loading = true;
      const params = {
        accountId: this.accountId,
      };
      axios.get('/pathway-course-lists', {
          params: params
      })
      .then((resp) => {
          this.loading = false;
          this.course_lists = resp.data;
      })
      .catch(error => {});
    },
    getStatus: function(status) {
      var status_val = this.status_options.findIndex(item => item.value === status);
      return this.status_options[status_val].text;
    },
    getDate(value) {
      return moment(String(value)).utc().format('MM/DD/YYYY')
    },
  },
  created() {
    this.fetchCourseListitems();
  },
}

</script>

<style scoped>
table thead tr {
  background-color: #00ACEE;
  color: #FFFFFF;
}

table tbody button {
  background-color: white;
  color: black;
  border: 1px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_pathway_course_lists.vue